"use strict";

const style = require("!!css-loader!./style/index.css").default;


module.exports =`
    <style>${style}</style>
    <div class="timepicker-container">
       <div class="swiftref-input">
            <div style="display: flex; align-items: center;">
                <label></label>
            </div>
            <div class="input-container">
                <input>
                <swiftref-icon kind="clock"></swiftref-icon>
            </div>
            <swiftref-message></swiftref-message>
        </div>
        
    <div class="timepicker-panel">
        <div class="time-selectors">
            <div class="time-column hour-column">
              <button class="btn increment-btn" data-type="hour"><swiftref-icon kind="arrow-up-green"></swiftref-icon></button>
              <div class="hour-selector" _tabindex="0"></div>
              <button class="btn decrement-btn" data-type="hour"><swiftref-icon kind="arrow-down-green"></swiftref-icon></button>
            </div>
            
            <p>:</p>
            
            <div class="time-column minute-column">
              <button class="btn increment-btn" data-type="minute"><swiftref-icon kind="arrow-up-green"></swiftref-icon></button>
              <div class="minute-selector" _tabindex="0"></div>
              <button class="btn decrement-btn" data-type="minute"><swiftref-icon kind="arrow-down-green"></swiftref-icon></button>
            </div>
            
            <p class="second-separator">:</p>
            
            <div class="time-column second-column">
              <button class="btn increment-btn" data-type="second"><swiftref-icon kind="arrow-up-green"></swiftref-icon></button>
              <div class="second-selector" _tabindex="0"></div>
              <button class="btn decrement-btn" data-type="second"><swiftref-icon kind="arrow-down-green"></swiftref-icon></button>
            </div>
            
            <div class="time-column ampm-column">
              <button class="ampm-selector" _tabindex="0">AM</button>
            </div>
            </div>
            
            <div class="panel-footer">
                <swiftref-button kind="tertiary" class="now-btn">Now</swiftref-button>
                <div style="display: flex; gap: 4px;">
                    <swiftref-button kind="secondary" class="clear-btn">Clear</swiftref-button>
                    <swiftref-button class="done-btn">Done</swiftref-button>
                </div>
            </div>
        </div>
</div>
`;
